import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchPaymentConsentQuery,
  Flex_FetchPaymentConsentQueryVariables,
} from '~/typings/graphql';
import { PERCH_PAYMENT_CONSENT_KEY } from '~/utils/constants';
import { FETCH_PAYMENT_CONSENT } from './fetch-payment-consent.queries';

export type PaymentConsentVersion =
  Flex_FetchPaymentConsentQuery['currentContractVersions'][number];

// Payment consent is no longer part of the signup contract template's contract set, so it is
// resolved from the current consent versions by internal name, the same way FICO consent is.
export const fetchPaymentConsent = async (): Promise<PaymentConsentVersion | undefined> => {
  const { data } = await apolloClient.query<
    Flex_FetchPaymentConsentQuery,
    Flex_FetchPaymentConsentQueryVariables
  >({
    query: FETCH_PAYMENT_CONSENT,
    variables: { internalName: [PERCH_PAYMENT_CONSENT_KEY] },
    fetchPolicy: 'no-cache',
  });

  return data.currentContractVersions?.[0];
};
